// The `HighlightCategoryTastic` component fetches carousel data based on a specific heading,
// such as "SALE," from the provided Tastic data. It then passes the relevant carousel content
// to the `HighlightCategorySection` component for rendering. This setup allows for dynamic and
// reusable content display, tailored to the heading's criteria. It leverages a modular approach,
// making it easier to manage and customize category highlights in the UI.

'use client';

import HighlightCategorySection from 'components/commercetools-ui/organisms/content/hightlight-category';
import { TasticProps } from 'frontastic/tastics/types';
import React from 'react';
import { Carousel, CarouselTasticData } from 'types/next';
import useLocale from 'helpers/hooks/useLocale';

const HighlightCategoryTastic = ({ data }: TasticProps<CarouselTasticData>) => {
  const { getCurrency } = useLocale();
  const selectedLocale = getCurrency() === 'GBP' ? 'en-GB' : 'en-EU';

  const categoryContent = data?.data?.dataSource?.carousels?.find(
    (content: Carousel) => content?.contentID === data?.contentID,
  ) as Carousel;

  // Only render if isShow for the current locale is true
  if (!categoryContent?.isShow?.[selectedLocale]) {
    return null;
  }

  return (
    <>
      <HighlightCategorySection content={categoryContent} />
    </>
  );
};

export default HighlightCategoryTastic;
